import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import vtkOpenGLRenderWindow from '@kitware/vtk.js/Rendering/OpenGL/RenderWindow';
import { forwardRef, useRef, useEffect, useMemo, useImperativeHandle } from 'react';
import deletionRegistry from '../utils/DeletionRegistry.js';
import useGetterRef from '../utils/useGetterRef.js';
import useUnmount from '../utils/useUnmount.js';
import { OpenGLRenderWindowContext } from './contexts.js';

const RENDERWINDOW_STYLE = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
};
var OpenGLRenderWindow = forwardRef(function OpenGLRenderWindow(props, fwdRef) {
    const rwContainerRef = useRef(null);
    const [viewRef, getRWView] = useGetterRef(() => {
        const view = vtkOpenGLRenderWindow.newInstance();
        deletionRegistry.register(view, () => view.delete());
        return view;
    });
    useEffect(() => {
        const view = getRWView();
        view.setContainer(rwContainerRef.current);
        return () => {
            // FIXME setContainer API should allow null
            view.setContainer(null);
        };
    }, [getRWView]);
    useUnmount(() => {
        if (viewRef.current) {
            deletionRegistry.markForDeletion(viewRef.current);
            viewRef.current = null;
        }
    });
    const api = useMemo(() => ({
        get: getRWView,
        getContainer: () => rwContainerRef.current,
    }), [getRWView]);
    useImperativeHandle(fwdRef, () => api);
    const { children, style, renderWindowStyle } = props, containerProps = __rest(props, ["children", "style", "renderWindowStyle"]);
    const containerStyle = useMemo(() => (Object.assign({ position: 'relative', width: '100%', height: '100%' }, style)), [style]);
    const rwContainerStyle = useMemo(() => (Object.assign(Object.assign({}, RENDERWINDOW_STYLE), renderWindowStyle)), [renderWindowStyle]);
    return (jsxs("div", Object.assign({}, containerProps, { style: containerStyle }, { children: [jsx("div", { ref: rwContainerRef, style: rwContainerStyle }), jsx(OpenGLRenderWindowContext.Provider, Object.assign({ value: api }, { children: children }))] })));
});

export { OpenGLRenderWindow as default };
